import React from 'react';
import GiftsPage from './GiftsPage';
import { GiftsPageMobile } from './GiftsPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const GiftsPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <GiftsPageMobile /> : <GiftsPage />;
};

export default GiftsPageWrapper; 